import { ApiUtility, IApiResponse } from "../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "./ItemsService";
import { LedgerStatus } from "./LedgerService";
export interface ITDSDetail {
  natureOfPayment: string;
  sectionKey: number;
  section: string;
  effectiveFrom: string;
  effectiveTo: string;
  limitType: Limit_Type;
  transactionType: Transaction_Type;
  rateDetail: {
    thresholdLimit: number;
    rates: {
      indHUFRate: number;
      otherRate: number;
      ifPANNotRate: number;
    };
  };
  form: string;
  status: LedgerStatus;
  id?: string;
}

export interface ITCSDetail {
  natureOfCollection: string;
  section: string;
  effectiveDate: string;
  rate: number;
  status: LedgerStatus;
  id?: string;
}

export enum Limit_Type {
  Yearly,
  Monthly,
  PerTransaction,
}

export enum Transaction_Type {
  Domestic,
  International,
}

class TdsTcsService {
  route = "V1/API/Billing";
  // TCS Services

  // https://localhost:7142/v1/API/Billing
  postTCS = (companyId: string, params: any, id?: string) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_TCS/${companyId}/${id ? id : ""}`,
      params
    );

  // https: //localhost:7142/v1/API/Acc_TCS/6717a034990705ff19c4460e
  getTCSByID = (companyId: string, id: string) =>
    ApiUtility.get(`${this.route}/Acc_TCS/${companyId}/${id}`);

  // https: //localhost:7142/v1/API/Acc_TCS/GetTCSList?start=0&length=0
  getTCSList = (
    companyId: string,
    start: number,
    length: number,
    search?: string,
    status: LedgerStatus = LedgerStatus.active
  ) => {
    return ApiUtility.getResult(
      `${this.route}/Acc_TCS/${companyId}/GetTCSList`,
      {
        start,
        length,
        search,
        status,
      }
    );
  };
  // MakeTCSActiveDeactive;
  makeTCSActiveDeactive = (companyId: string, tcsId: string) =>
    ApiUtility.post<IApiResponse<boolean>>(
      `${this.route}/Acc_TCS/${companyId}/MakeTCSActiveDeactive/${tcsId}`,
      {}
    );

  // TDS Services
  postTDS = (companyId: string, params: any, id?: string) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/Acc_TDS/${companyId}/${id ? id : ""}`,
      params
    );

  // https://localhost:7142/v1/API/Acc_TDS/6717b3c9990705ff19c44610
  getTDSByID = (companyId: string, id: string) =>
    ApiUtility.get<IApiResponse<ITDSDetail>>(
      `${this.route}/Acc_TDS/${companyId}/${id}`
    );

  // https://localhost:7142/v1/API/Acc_TDS/673c8700e66b827f6547c71c/GetTDSList?start=0&length=15&search=asas
  getTDSList = (
    companyId: string,
    start: number,
    length: number,
    search?: string,
    status: LedgerStatus = LedgerStatus.active
  ) => {
    return ApiUtility.getResult<ITDSDetail[]>(
      `${this.route}/Acc_TDS/${companyId}/GetTDSList`,
      {
        start,
        length,
        search,
        status,
      }
    );
  };

  // MakeTDSActiveDeactive;
  makeTDSActiveDeactive = (companyId: string, tdsId: string) =>
    ApiUtility.post<IApiResponse<boolean>>(
      `${this.route}/Acc_TDS/${companyId}/MakeTDSActiveDeactive/${tdsId}`,
      {}
    );

  // https://localhost:7142/v1/API/Acc_TDS/673c8700e66b827f6547c71c/GetCompanyTDSList?start=0&length=0

  // getCompanyTDSList = (
  //   companyId: string,
  //   start: number,
  //   length: number,
  //   search?: string
  // ) =>
  //   ApiUtility.getResult(
  //     `${this.route}/Acc_TDS/${companyId}/GetCompanyTDSList`,
  //     {
  //       search,
  //       start,
  //       length,
  //     }
  //   );
}
export default new TdsTcsService();
